/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IProductSpecificationViewProps } from '@msdyn365-commerce-modules/product-specification/src/modules/product-specification/./product-specification';
import { IProductSpecificationProps } from '../definition-extensions/product-specification.ext.props.autogenerated';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps & IProductSpecificationProps<{}>> = props => {
    const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps, productSpecificationResult } = props;

    const rowdata =
        productSpecificationResult &&
        ArrayExtensions.hasElements(productSpecificationResult) &&
        productSpecificationResult.filter(row => !ObjectExtensions.isNullOrUndefined(row));

    const { productAttributesToHide } = props.config;
    if (rowdata && productAttributesToHide && productAttributesToHide.length > 0 && rowdata.length > 0) {
        for (let index = 0; index < productAttributesToHide.length; index++) {
            // const rowIndex = rowdata.findIndex(
            //     row => row?.props.productName.toLowerCase() === productAttributesToHide[index].toLowerCase().trim()
            // );
            // Fix for product description broken on 10.0.36 - Fixed by Prasanna Ruwangana
            const rowIndex = rowdata.findIndex(row => {
                if (row && row.props && row.props.children[0] && row.props.children[0].props && row.props.children[0].props.productName) {
                    return row.props.children[0].props.productName.toLowerCase() === productAttributesToHide[index].toLowerCase().trim();
                }
                return false; // Handle case where row, row.props, or row.props.productName is undefined
            });
            if (rowIndex >= 0) {
                rowdata.splice(rowIndex, 1);
            }
        }
        return _renderRowData();
    } else {
        return _renderRowData();
    }

    function _renderRowData(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | null {
        return rowdata && ArrayExtensions.hasElements(rowdata) ? (
            <Module {...ProductSpecification}>
                {props.title}
                <Node {...ProductSpecificationTableProps}>
                    <Node {...ProductSpecificationTableBodyProps}>{rowdata}</Node>
                </Node>
            </Module>
        ) : null;
    }
};

export default ProductSpecificationView;
